import { render, staticRenderFns } from "./FooterNavigationMenu.vue?vue&type=template&id=e2cede4c"
import script from "./FooterNavigationMenu.vue?vue&type=script&lang=js"
export * from "./FooterNavigationMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppLink: require('/vercel/path0/components/shared/AppLink.vue').default,TriangleRightIcon: require('/vercel/path0/components/icons/TriangleRightIcon.vue').default,Container: require('/vercel/path0/components/shared/Container.vue').default})
